import './LegalMentions.scss'

function LegalMentions() {
    
   
    return  (      
        <div className='mentionsContainer'>
            <h4 className='mentionsContainer_title'>Mentions légales</h4>
            <p className='mentionsContainer_text'>
                Bau Architecture, ****type de structure******, <br/>
                domicilié ****adresse****** <br/><br/>
                SIRET : ********* <br/>
                Activité principale : ****type d'activité****** <br/>
                Date de création **** <br/>
                TVA : **** <br/>
                APE : **** <br/><br/>

                Direction de la publication : Amata Zdziobeck <br/><br/>
                Crédits photos : © *********<br/><br/>

                Webdesign, développement web :<br/> 
                <a href='http://www.bengibert.com'>Ben Gibert</a><br/>
                Site web développé avec ReactJS / NodeJS<br/><br/>

                Hébergeur :<br/>
                Société : OVH <br/>
                Adresse web : www.ovh.com<br/>
                Adresse Postale : <br/>
                2 rue kellermann – BP 80157 – 59053 ROUBAIX Cedex 1<br/>
                Téléphone : +33 (0)8 203 203 63<br/>
                Mail : support@ovh.com<br/><br/>

                Conditions d'utilisation du site Internet www.*********.com <br/><br/>
                Le site et chacun des éléments, y compris mais sans limitation les marques, les logos, icônes, infographies, photographies, projets, textes qui le composent sont protégés au titre de la législation internationale de la propriété intellectuelle. Les contenus figurant sur le site sont la propriété de Amata Zdziobeck. Toute utilisation, reproduction ou représentation, par quelque procédé que ce soit, et sur quelque support que ce soit, de tout ou partie du site et/ou des éléments qui le composent n'est pas autorisée sans le consentement expresse de Amata Zdziobeck.
            </p>
        </div>
    )
}

export default LegalMentions